import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const GlobalCompetitionCard = ({
  userRank = null,
  isLive = false,
  onNavigate,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    } else {
      navigate("/globalcompetition");
    }
  };

  return (
    <button onClick={handleClick} className="block w-full text-left">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-dark-grey via-gray-700 to-gray-800 border border-gray-600/30 shadow-lg">
        {/* Live indicator */}
        {isLive && (
          <div className="absolute top-4 right-4 flex items-center gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
            </span>
            <span className="text-xs font-medium text-green-400">LIVE</span>
          </div>
        )}

        <div className="p-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-deep-red flex items-center justify-center shrink-0 shadow-lg">
              <FontAwesomeIcon icon={faGlobe} className="text-white text-xl" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-bold text-white">
                Global Competition
              </h3>
              {userRank && (
                <p className="text-white/70 text-sm">
                  Your Rank:{" "}
                  <span className="text-gold font-bold">#{userRank}</span>
                </p>
              )}
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-4 flex items-center justify-between bg-deep-red hover:bg-bright-red transition-colors rounded-lg px-4 py-2.5">
            <span className="text-white text-sm font-medium">
              View Competition
            </span>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-white text-sm"
            />
          </div>
        </div>
      </div>
    </button>
  );
};

export default GlobalCompetitionCard;
